import { gql } from '@apollo/client'

export const GET_KNOWLEDGE_BASE_PROJECT_INFO = gql`
    query GetKnowledgeBaseProjectInfo($input: GetProjectInfoInput!) {
        getKnowledgeBaseProjectInfo(input: $input) {
            projectId
            sections {
                projectProductFamilyId
                sectionNumber
                sectionName
                divisionNumber
                divisionName
            }
        }
    }
`

const FINDING_FIELDS = gql`
    fragment FindingFields on SpecIntelligenceFinding {
        id
        reportId
        category
        description
        sectionNumber
        sectionName
        sectionElementId
        referencedSectionNumber
        sourceParagraphs {
            contentItemId
            breadcrumb
        }
        isAI
        resolutionState
        resolvedByName
        resolvedAt
    }
`

const REPORT_FIELDS = gql`
    ${FINDING_FIELDS}
    fragment ReportFields on SpecIntelligenceReport {
        id
        projectId
        runDate
        runByName
        sectionCount
        sectionNumbers
        status
        instanceId
        errorMessage
        errorType
        findings {
            ...FindingFields
        }
    }
`

export const GET_LATEST_SPEC_INTELLIGENCE_REPORT = gql`
    ${REPORT_FIELDS}
    query GetLatestSpecIntelligenceReport($input: GetLatestSpecIntelligenceReportInput!) {
        getLatestSpecIntelligenceReport(input: $input) {
            ...ReportFields
        }
    }
`

export const GET_SPEC_INTELLIGENCE_REPORT = gql`
    ${REPORT_FIELDS}
    query GetSpecIntelligenceReport($input: GetSpecIntelligenceReportInput!) {
        getSpecIntelligenceReport(input: $input) {
            ...ReportFields
        }
    }
`

export const GET_SPEC_INTELLIGENCE_SECTION_STALENESS = gql`
    query GetSpecIntelligenceSectionStaleness($input: GetSectionInfoHeadersInput!) {
        getKnowledgeBaseSectionInfoHeaders(input: $input) {
            sectionNumber
            lastInvalidatedAt
        }
    }
`

export const GET_SPEC_INTELLIGENCE_RUN_STATUS = gql`
    query GetSpecIntelligenceRunStatus($input: GetBackendProcessStatusInput!) {
        getSpecIntelligenceRunStatus(input: $input) {
            state
            progressPercentage
            statusMessage
            errorMessage
            result {
                reportId
                findingCount
                sectionCount
            }
        }
    }
`
